module.exports = "<div id=\"transi-video\">\r\n    <div class=\"video-wrapper\">\r\n        <video preload playsinline=\"playsinline\" muted=\"muted\"></video>\r\n    </div>\r\n\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./project/_src/transition-videos/transi-video.html
// module id = 6
// module chunks = 0